import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/ui/Header";
import HeroSection from "./components/HeroSection";
import GuideCard from "./components/GuideCard";
import Icon from "../../components/AppIcon";
import Button from "../../components/ui/Button";
import guides from "../../data/guides";

const SherpaGuideProfiles = () => {
  const navigate = useNavigate();

  const handleBookConsultation = (guide = null) => {
    navigate("/booking-consultation-center");
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-28">
          <HeroSection onBookConsultation={() => handleBookConsultation()} />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

          <div className="mb-16">
            <div className="text-center mb-10">
              <h2 className="section-heading text-foreground mb-4">
                Our <span style={{ color: "#2d5016" }}>Expert</span> Sherpa Guides & Trekking Team
              </h2>
              <p className="text-lg text-text-secondary leading-relaxed max-w-3xl mx-auto">
                Sherpa Trekker's team brings together experts across every
                dimension of the trekking industry — from trip planning and
                cultural interpretation to high-altitude rescue and expedition
                logistics. Our people's experience, passion, and loyalty are the
                true wealth of our company, and the thin line between a
                perfectly executed adventure and an average one.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {guides?.map((guide) => (
                <GuideCard
                  key={guide?.id}
                  guide={guide}
                />
              ))}
            </div>
          </div>

          <div className="bg-primary/5 rounded-2xl p-8 md:p-12 text-center">
            <div className="max-w-3xl mx-auto">
              <h2 className="section-heading text-foreground mb-4">
                Ready to{" "}
                <span style={{ color: "#c4873a" }}>Meet Your Guide</span>?
              </h2>
              <p className="text-lg text-text-secondary mb-8 leading-relaxed">
                Every great adventure begins with the right guide. Let our
                experts help you choose the perfect Sherpa guide for your
                Himalayan journey based on your experience level, interests, and
                goals.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button
                  variant="default"
                  size="lg"
                  className="btn-conversion"
                  iconName="Calendar"
                  iconPosition="left"
                  onClick={() => handleBookConsultation()}
                >
                  Book Free Consultation
                </Button>
                <Button
                  variant="outline"
                  size="lg"
                  iconName="MessageCircle"
                  iconPosition="left"
                  onClick={() => navigate("/booking-consultation-center")}
                >
                  Chat with Expert
                </Button>
              </div>
            </div>
          </div>
        </div>
      </main>

      <footer className="bg-foreground text-white mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 mountain-gradient rounded-lg flex items-center justify-center mr-3">
                  <img
                    src="/assets/images/logo.jpeg"
                    alt="Sherpa Trekker Logo"
                  />
                </div>
                <span className="text-xl font-headline font-bold">
                  Sherpa Trekker
                </span>
              </div>
              <p className="text-white/80 mb-4 max-w-md">
                Connecting adventurous souls with the wisdom of the Himalayas
                through authentic Sherpa-guided experiences.
              </p>
              <div className="flex space-x-4">
                <Icon
                  name="Facebook"
                  size={20}
                  className="text-white/60 hover:text-white cursor-pointer"
                />
                <Icon
                  name="Instagram"
                  size={20}
                  className="text-white/60 hover:text-white cursor-pointer"
                />
                <Icon
                  name="Twitter"
                  size={20}
                  className="text-white/60 hover:text-white cursor-pointer"
                />
              </div>
            </div>

            <div>
              <h3 className="font-headline font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2 text-white/80">
                <li>
                  <a href="/trek-discovery-hub" className="hover:text-white">
                    Discover Treks
                  </a>
                </li>
                <li>
                  <a href="/activities" className="hover:text-white">
                    Activities & Tours
                  </a>
                </li>
                <li>
                  <a href="/nepal-info" className="hover:text-white">
                    Nepal Travel Info
                  </a>
                </li>
                <li>
                  <a href="/traveler-stories-hub" className="hover:text-white">
                    Traveler Stories
                  </a>
                </li>
                <li>
                  <a
                    href="/booking-consultation-center"
                    className="hover:text-white"
                  >
                    Book Consultation
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="font-headline font-semibold mb-4">Contact</h3>
              <ul className="space-y-2 text-white/80">
                <li className="flex items-center">
                  <Icon name="Phone" size={16} className="mr-2" />
                  +977-9851157213
                </li>
                <li className="flex items-center">
                  <Icon name="Mail" size={16} className="mr-2" />
                  imsherpatrekker@gmail.com
                </li>
                <li className="flex items-center">
                  <Icon name="MapPin" size={16} className="mr-2" />
                  Thamel, Kathmandu, Nepal
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/20 mt-8 pt-8 text-center text-white/60">
            <p>
              &copy; {new Date()?.getFullYear()} Sherpa Trekker. All rights
              reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SherpaGuideProfiles;
